import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired
};
const defaultProps = {};

const InputWrapper = styled.input`
  border-radius: 3px;
  border: 1px solid #c9c9c9;
  padding: 15px 10px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
  ${props => `
    border-color: ${props.hasError && "red"}
  `};
`;

function Input({
  validateFormat,
  hasError,
  handleChange,
  id,
  value,
  placeholder,
  clickOutValidated
}) {
  return (
    <InputWrapper
      placeholder={placeholder}
      onChange={handleChange}
      id={id}
      name={id}
      value={value}
      hasError={hasError}
      onBlur={validateFormat}
    />
  );
}

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export { propTypes, defaultProps };
export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js